import { render } from "./CandidateModal.vue?vue&type=template&id=946919a2&scoped=true"
import script from "./CandidateModal.vue?vue&type=script&lang=js"
export * from "./CandidateModal.vue?vue&type=script&lang=js"

import "./CandidateModal.vue?vue&type=style&index=0&id=946919a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946919a2"]])

export default __exports__